import React from "react";
import * as THREE from "three";

const MastColumnBeam = ({ column, gridScale, colorList, luminaires }) => {
    const { height = 6, point } = column.values;
    const { x, y } = point;
    const radius = 0.2;
    const defaultBaseColor = "lightgray";
    const columnBaseZ = (height * gridScale) / 2;
    const { lanterns = [] } = column.values;

    const topOfColumn = new THREE.Vector3(
        x * gridScale,
        y * gridScale * -1,
        columnBaseZ + (height * gridScale) / 2 - 0.05
    );

    return (
        <>
            <mesh
                position={[x * gridScale, y * gridScale * -1, columnBaseZ]}
                rotation={[Math.PI / 2, 0, 0]}
            >
                <cylinderGeometry
                    args={[radius * gridScale, radius * gridScale, height * gridScale, 32]}
                />
                <meshStandardMaterial color={defaultBaseColor} />
            </mesh>

            {lanterns.map((lantern, index) => {
                const { beamAimingInfo } = lantern;
                if (!beamAimingInfo || !beamAimingInfo.beamEndPoint) return null;

                const { x: endX, y: endY } = beamAimingInfo.beamEndPoint;
                const beamEnd = new THREE.Vector3(
                    endX * gridScale,
                    endY * gridScale * -1,
                    0
                );

                const points = [topOfColumn, beamEnd];
                const geometry = new THREE.BufferGeometry().setFromPoints(points);

                const luminaireIndex = luminaires.indexOf(lantern.luminaireId);
                const resolvedColor =
                    luminaireIndex !== -1 && colorList[luminaireIndex]
                        ? colorList[luminaireIndex]
                        : defaultBaseColor;

                return (
                    <line key={index} geometry={geometry}>
                        <lineBasicMaterial
                            color={resolvedColor === "#212529" ? defaultBaseColor : resolvedColor}
                            linewidth={2}
                        />
                    </line>
                );
            })}
        </>
    );
};

export default MastColumnBeam;
